import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import {IProps, IState} from './types';
import * as S from './styles';
import {IElement, IPickerType, ITextAttributes} from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";
import arrowdown from "assets/svgs/arrowdown.svg"
import arrowup from "assets/svgs/arrowup.png"
import { IDSConfig } from '@state/dsconfig/types';
import { findFontByNameOrId } from '@utils/fonts';
import ToolTip from '@components/Tooltip';

const FontFamillyComandOption:React.FC<IProps> = (props) => {
  let context = useContext(Context);
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [fontFamily, setFontFamily]= useState<string | undefined>(undefined);
  const [lastFontFamily, setLastFontFamily]= useState<string | undefined>(undefined);
  const [isSearching, setIsSearching]= useState(false);
  const [searchValue, setSearchValue]= useState("");

  useEffect(() => {
    let font = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontFamily", "Text", context.editorStatus.textSelectionInformation);
    if (font) {
      const oemFont = findFontByNameOrId(dsConfig.brands, "id", font);
      if (oemFont) font = oemFont.name;
    }
    setFontFamily(font);
    setLastFontFamily(font);
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

  useEffect(() => {
    setIsSearching(false);
    setSearchValue("");
    if (context.editorStatus.currentPicker==="FontFamily") {
      context.onShowPicker("FontFamily",{isSearching: false, searchValue: ""});
    }
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0]]);

  const SetFontSelecting = () => {
    const picker = (context.editorStatus.currentPicker==="FontFamily")?undefined:"FontFamily";
    context.onShowPicker(picker,{isSearching: isSearching, searchValue: searchValue});
  }

  const handleChangeInput = (e: any) => {
    const text = (e.target as HTMLSpanElement).innerText;
    if(lastFontFamily!==text) {
      setIsSearching(true);
      setSearchValue(text);
      setLastFontFamily(text);
      context.onShowPicker("FontFamily",{isSearching: true, searchValue: text});
    } 
  }

  return (
    <S.Root>
      <ToolTip tip={fontFamily} >
      <S.Rectangle isSelecting={(context.editorStatus.currentPicker==="FontFamily")}>
      
        <S.FontName 
          onKeyUp={(e) => handleChangeInput(e)}
          contentEditable={true}>                      
            {fontFamily}                       
        </S.FontName>     
        <S.Arrow onClick={() => {setIsSearching(false); SetFontSelecting()}}>
          <img src={(context.editorStatus.currentPicker==="FontFamily")? arrowup : arrowdown}></img>
        </S.Arrow>
      </S.Rectangle>
      </ToolTip>
  </S.Root>
  );
}

export default FontFamillyComandOption;